import React from 'react';

export function BlankStoryIllustration() {
  return (
    <div className="block-content">
      <div className="story-pending-filters">
        <img
          src="https://cdn.forge.tylertech.com/v1/images/spot-hero/chickadee-guide-spot-hero-01.svg"
          alt="Apply filters to view content"
          className="pending-filters-illustration"
        />
        <p className="forge-typography--body4">
          Set your filters above and click Run report to generate your data.
        </p>
      </div>
    </div>
  );
}
